export default __webpack_public_path__ + "static/media/benefits_1.62ff76f4.png";